var _currentPlayingBtn = null;

function stopQuestionAudio() {
    var audio = document.getElementById("myAudio");
    if (!audio) return;
    audio.pause();
    audio.src = "";
    document.querySelectorAll(".btn-question").forEach(function (el) {
        el.classList.remove("active");
    });
    _currentPlayingBtn = null;
}

document.addEventListener("click", function (e) {
    if (e.target.closest(".btn-close")) {
        stopQuestionAudio();
        return;
    }

    var btn = e.target.closest(".btn-question");
    if (!btn) return;

    var li = btn.closest("li[data-music]");
    if (!li) return;

    var audio = document.getElementById("myAudio");
    var src = li.getAttribute("data-music");

    // So sánh theo button element để tránh lỗi khi nhiều đáp án cùng URL nhạc
    var isSame = (_currentPlayingBtn === btn) && !audio.paused;

    audio.pause();
    if (isSame) {
        _currentPlayingBtn = null;
        return;
    }

    // Không quản lý active/radio ở đây — để ddtk-ld-music.js xử lý
    _currentPlayingBtn = btn;
    audio.src = src;
    audio.load();
    audio.play();
});

var _popupQuestionObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        if (mutation.attributeName === "class") {
            var popup = mutation.target;
            if (!popup.classList.contains("active")) {
                stopQuestionAudio();
            }
        }
    });
});

window.addEventListener("load", function () {
    var popupQuestion = document.getElementById("popup_question");
    if (popupQuestion) {
        _popupQuestionObserver.observe(popupQuestion, { attributes: true });
    }
});

window.addEventListener("load", function () {
    document.querySelectorAll('.popup_getlist2 .btn_get').forEach(function(btn) {
        
        if (btn.classList.contains('received')) {
            btn.textContent = btn.getAttribute('data-received');
        } else {
            btn.textContent = btn.getAttribute('data-dafault');
        }
        
    });
    // if ($("#popup_reward").hasClass("gift-1")) {
    //     console.log("aaaa");
    //     $("#popup_reward .bg-vongquay").attr("src","assets/libraryMainsite-t-popup/images/bg-login.png");
    // }
    // else {
    //     $("#popup_reward .bg-vongquay.MS__pc").attr("src","assets/libraryMainsite-t-popup/images/bg.png");
    //     $("#popup_reward .bg-vongquay.MS__mobile").attr("src","assets/libraryMainsite-t-popup/images/bg-mb.png");
    // }
});